import { render, staticRenderFns } from "./tiaoxingma.vue?vue&type=template&id=44cc03cf&scoped=true&"
import script from "./tiaoxingma.vue?vue&type=script&lang=js&"
export * from "./tiaoxingma.vue?vue&type=script&lang=js&"
import style0 from "./tiaoxingma.vue?vue&type=style&index=0&id=44cc03cf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cc03cf",
  null
  
)

export default component.exports